import sendReportRequest from './sendReportRequest';

const fetchReportOverview = async ({ dateRange, from, to, unit, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/overview',
    dateRange,
    from,
    to,
    unit,
    reportingType,
  });

  return reponseData;
};

export default fetchReportOverview;
